import { Phone } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { PageHeader } from "../components/PageHeader";
import { FAQAccordion } from "../components/FAQAccordion";
import { faqItems } from "../config/faq";
import { Reveal } from "../components/Reveal";
import { InquiryButton } from "../components/BookingButton";
import { siteConfig } from "../config/site";
import { track } from "../lib/tracking";

export default function FAQ() {
  const { t } = useLanguage();
  const primary = siteConfig.contacts[0];
  return (
    <main data-testid="faq-page">
      <SEOHead title={t.meta.faq.title} description={t.meta.faq.description} />
      <PageHeader eyebrow={t.faqPage.eyebrow} title={t.faqPage.title} text={t.faqPage.text} crumb={t.nav.faq} testId="faq-header" />
      <section className="container-x grid gap-12 pb-24 lg:grid-cols-12 md:pb-32">
        <Reveal className="lg:col-span-8"><FAQAccordion items={faqItems} /></Reveal>
        <Reveal className="lg:col-span-4" delay={0.1}>
          <div className="card sticky top-32 p-7">
            <h2 className="font-display text-xl font-medium">{t.faqPage.moreTitle}</h2>
            <p className="mt-2 text-sm text-charcoal-500 leading-relaxed">{t.faqPage.moreText}</p>
            <div className="mt-6 flex flex-col gap-3">
              <a href={`tel:${primary.phoneHref}`} className="btn-dark" onClick={() => track("phone_click")} data-testid="faq-phone-button"><Phone className="h-4 w-4" aria-hidden /> {primary.phone}</a>
              <InquiryButton variant="outline" testId="faq-inquiry-button" />
            </div>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
